import api from 'Application/api/api';

const assignCampaignProjects = async (signal, values) => {
	const response = await api.post('/finances/assign-projects', values, {
		signal,
	});

	if (!response || !response.data) {
		return response;
	}

	return {
		...response,
	};
};

export default assignCampaignProjects;
